import geneesmiddelApi from "../../api/geneesmiddelApi";
import mergeDeep from "../../util/mergeDeep";

export default class GeneesmiddelOverzichtPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        this.context.props.loadLayout();
        const context = this.context;
        const pageSize = context.state.pageSize;
        const filterQueryStringParameter = this.getQueryStringParameterByName("naam");

        this.onSearch(null, 1, pageSize, filterQueryStringParameter, true);
    }

    getQueryStringParameterByName(name) {
        let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    onSearch(event, pageNo, pageSize, naam, sortAscending) {
        if (event) {
            event.preventDefault();
        }

        const context = this.context;
        const props = context.props;
        const state = context.state;
        const ajaxActions = props.ajaxActions;

        let filterModel = mergeDeep({}, state.filterModel);
        filterModel.pageSize = pageSize;
        filterModel.pageNo = pageNo;
        filterModel.sortAscending = sortAscending;
        filterModel.naam = naam? naam : "";

        ajaxActions.started();
        geneesmiddelApi.search(filterModel)
            .then((response) => {
                ajaxActions.ended();
                this._processModel(response, filterModel);
            })
            .catch((ex) => {
                ajaxActions.failed();
                props.throwException(ex);
            });
    }

    _processModel(response, filterModel) {
        this.context.setState({
            pagedModels: response.data.pagedGeneesmiddelen,
            filterModel,
            geneesmiddelNaamFromFilter: filterModel.naam,
            filterItems: this.context.state.filterItems.filter(el => el.title.toLowerCase().includes(filterModel.naam.toLowerCase()))
        });
    }

    onPageSizeChange(pageSize) {
        const context = this.context;
        const naam = context.state.filterModel.naam;
        this.onSearch(null, 1, pageSize, naam, true);
    }

    onPageNoChange(pageNo) {
        const context = this.context;
        const pageSize = context.state.filterModel.pageSize;
        const naam = context.state.filterModel.naam;
        this.onSearch(null, pageNo, pageSize, naam, true);
    }

    _sortColumn() {
        const context = this.context;
        const state = context.state;
        const filterModel = state.filterModel;

        this.onSearch(null, 1, filterModel.pageSize, filterModel.naam, !filterModel.sortAscending);
    }

    onSortTable() {
        this._sortColumn();
    }

    onChangeFilter(event) {
        let value = event.target.value;
        const context = this.context;
        const property = event.target.name;
        const filterModel = mergeDeep({}, context.state.filterModel);
        filterModel.naam = value;

        context.setState({
            [property]: value,
            filterModel
        });
    }

    onClickShowDetail(id) {
        const context = this.context;
        const props = context.props;
        const ajaxActions = props.ajaxActions;
        window.parent.scrollTo(0, 750);

        ajaxActions.started();
        geneesmiddelApi.get(id)
            .then((response) => {
                ajaxActions.ended();
                this._processDetailModel(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                props.throwException(ex);
            });
    }

    onCancelShowDetail() {
        this.context.setState({
            detailModalOpen: false,
            detailModel: {}
        });
    }

    onSelectSearchOption(event, data) {
        if (data) {
            this.onSearch(null, 1, 20, data.result.title, true);
        }
    }

    onChangeSelectOption(event, data) {
        const selectedResult = data.result? data.result.title: "";

        this.context.setState({
            selectedResult: selectedResult
        });
    }

    onSearchTextChange(event, data) {
        const context = this.context;
        const filter = event.target.value;
        const selectedResult = data.result? data.result.title: "";

        context.setState({
            geneesmiddelNaamFromFilter: filter,
            selectedResult: selectedResult
        });

        if (filter.length >= 3) {
            this.callFilterList(filter);
        }
    }

    callFilterList(filter) {
        const context = this.context;
        const props = context.props;
        const ajaxActions = props.ajaxActions;

        clearTimeout(context.state.timeOut);
        context.state.timeOut = setTimeout( function() {
            ajaxActions.started();
            geneesmiddelApi.listByAutocomplete(filter)
                .then(response => {
                    ajaxActions.ended();
                    context.setState({
                        filterItems: response.data.map(el => {
                            return { title: el };
                        })
                    });

                })
                .catch((ex) => {
                    ajaxActions.failed();
                    props.throwException(ex);
                });
        }, 500);
    }

    _processDetailModel(response) {
        this.context.setState({
            detailModel: response.data,
            detailModalOpen: true
        });
    }

    onKeyUpFilter(event) {
        if(event.keyCode === 13 && this.context.state.selectedResult === "") { //on enter
            this.onSearch(null, 1, 20, event.target.value, true);
            event.target.blur();
        }
    }
}